export class SubCategoryWiseActAndBudgetRevenueReq{
    divisionId:number;
    clientCode:string;
    categoryId:number;
    subCategoryId:number;
    startDate : string;
    endDate: string;
    groupBy: string;
}